<div class="language-picker">
  @for (lang of translate.getLangs(); track lang) {
    <div
      class="language"
      [class.selected]="lang === translate.currentLang"
      >
      @if (lang === 'en') {
        <img src="../../../assets/uk.png" alt="" (click)="changeLanguage(lang)" />
      }
      @if (lang === 'de') {
        <img src="../../../assets/de.png" alt="" (click)="changeLanguage(lang)" />
      }
    </div>
  }
</div>
